import React, { useState } from 'react';

const FormCrearCategoria = ({ handleClose }) => {
  const [data, setData] = useState({
    nombre: "",
    imagen: null
  });

  const handleInputChange = (e) => {
    const { name, value, type, files } = e.target;

    setData((prevData) => ({
      ...prevData,
      [name]: type === 'file' ? files[0] : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('nombre', data.nombre);
    if (data.imagen) {
      formData.append('imagen', data.imagen);
    }

    fetch("http://localhost:8080/api/categ", {
      method: "POST",
      headers: {
        'authorization': sessionStorage.getItem('token')
      },
      body: formData,
    })
      .then(response => response.json())
      .then(data => {
        console.log("Categoría creada:", data);
        alert('Categoría creada con éxito');
        handleClose();
      })
      .catch(error => console.error("Error al crear la categoría: ", error));
  };

  return (
    <>
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-8">
            <form onSubmit={handleSubmit}>
              <div className="form-floating">
                <input
                  type="text"
                  className="form-control"
                  id="floatingNombre"
                  value={data.nombre}
                  placeholder='Nombre'
                  onChange={handleInputChange}
                  name='nombre'
                  required
                />
                <label htmlFor="floatingNombre"><h4>Nombre</h4></label>
              </div>
              <br></br>
              <div className="form-group">
                <label htmlFor="imagen"><h4>Imagen</h4></label>
                <input
                  type="file"
                  className="form-control"
                  id="imagen"
                  onChange={handleInputChange}
                  name='imagen'
                  accept="image/*"
                />
              </div>
              <br></br>
              <button type="submit" className="btn btn-primary">Crear</button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormCrearCategoria;
